import { environment } from "../../../../environments/environment";

export const MODAL_PROSPECT_TITLE = `We're sorry!`;
export const MODAL_PROSPECT_SUBTITLE = `Unfortunately we don't deliver to your area!`;
export const MODAL_PROSPECT_TEXT_CONTENT = `Please email <b>${environment.config.contactEmail}</b> if you think this is a mistake.`